import { ActivatedRouteSnapshot, CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';
import { SnackbarService } from '@dss-libs/shared/utility/common-services';
import { filter, map, take } from 'rxjs';
import { EventTypeEnum, UserRole } from '@dss-libs/shared/type/common-types';
import { UserManagementService } from '@dss-libs/shared/data-access/users';
import { isUserAuthorized } from '@dss-libs/shared/utility/common-utilities';
export const RolesGuard: CanActivateFn = (route: ActivatedRouteSnapshot) => {
  const userManagementService = inject(UserManagementService);
  const router = inject(Router);
  const snackBarService = inject(SnackbarService);

  return toObservable(userManagementService.userProfileResource.status).pipe(
    filter((status) => status === 'resolved' || status === 'error'),
    take(1),
    map(() => {
      if (!userManagementService.userProfileResource.hasValue()) return false;
      const profile = userManagementService.userProfileResource.value();
      const authorizedRole: UserRole = route.data['authorizedRole'];
      if (!isUserAuthorized(profile.role, authorizedRole)) {
        snackBarService.showToaster(EventTypeEnum.ERROR, 'ERRORS.FORBIDDEN');
        return router.createUrlTree(['/']);
      }
      return true;
    })
  );
};
